import React, { useState, useEffect, useContext, useRef } from 'react';
import 'datatables.net-bs5';
import $ from 'jquery';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';
import { handleChange } from "../../Controller/CreateSaleOrderController";
import PartService from '../../../Parts/Controller/PartController';
import SaleOrderService from "../../Controller/SaleOrderController";
import { useNavigate } from 'react-router-dom';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
function SaleOrderShippedModal({ show, OnSuccess, onClose, parts, setParts, bnt_OrderNumber, saleOrderId, UnitOfSale = 0 }) {
    const navigate = useNavigate();
    const { theme } = useContext(ThemeContext);
    const getCurrentDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };

    const [formData, setFormData] = useState({
        vc_DeliveryCompanyName: "Stock System",
        dt_DeliveryDate: getCurrentDate(),
        bnt_OrderNumber: bnt_OrderNumber || '',
        bnt_DeliveryNumber: "",
        saleOrderId: saleOrderId
    });
    const [errors, setErrors] = useState({});
    const [stockLocationList, setStockLocationList] = useState([]);
    const [selectedDepot, setSelectedDepot] = useState({});
    const [showDepotModal, setShowDepotModal] = useState(false);
    const [activePartId, setActivePartId] = useState(null); // Tracks the part ID for which modal is opened
    const [saleItemID, setSaleItemID] = useState(null);
    const tableRef = useRef();

    const accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const truncateText = (text, maxLength = 30) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };

    const handleStart = (e) => {
        e.stopPropagation();
    };

    const fetchStockLocations = async (PartID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page if needed
            };
            const listOfLocations = await PartService.GetPartLocation(redirectCallback, PartID);
            debugger;
            setStockLocationList(listOfLocations);
            setActivePartId(PartID); // Set the current part ID for which locations are being loaded
        } catch (error) {
            console.error('Error fetching locations:', error);
        }
    };

    const handleDepotSelect = (depot) => {
        // Update selected depot for the specific PurchaseItemID (row)
        if (parseInt(depot.dec_Quantity).toFixed(2) > 0) {


            setSelectedDepot((prevState) => ({
                ...prevState,
                [saleItemID]: {
                    PK_StockLocation_ID: depot.PK_StockLocation_ID, // Set the selected depot ID
                    vc_Name: depot.vc_Name, // Set the selected depot name,
                    // DepotQuantity:depot.dec_Quantity
                }
            }));

            // If the selected depot is valid, update FK_Location_ID_Stock
            const updatedParts = parts.map(part => {
                debugger;
                if (part.PK_SalesOrderItem_ID === saleItemID) {
                    const updatedUnitOfSale = Math.min(depot.dec_Quantity, (part.vc_UnitOfSale - (parseInt(part.dec_QtyAllocated) + parseInt(part.dec_QuantityShipped)))); // Compare DepotQuantity and UnitOfSale
                    return {
                        ...part,
                        FK_Location_ID_Stock: depot.PK_StockLocation_ID, // Update location ID
                        DepotQuantity: updatedUnitOfSale, // Set vc_UnitOfSale based on comparison
                    };
                }
                return part;
            });

            setParts(updatedParts);  // Update parts with the new stock location
            setShowDepotModal(false); // Close the modal after selection
        }
        else {
            Swal.fire(
                '',
                'The selected depot must have the quantity',
                'warning'
            );
            return;
        }
    };

    const openDepotModal = (partId, saleItemID) => {
        setActivePartId(partId); // Part ID for loading depots
        setSaleItemID(saleItemID); // Set PurchaseItemID for the specific row
        fetchStockLocations(partId); // Load depots for the part
        setShowDepotModal(true); // Open the modal
    };
    const handlePartChange = (index, newValue) => {
        // Update the part with the new value entered by the user
        const updatedParts = [...parts]; // Assuming you have an array of parts
        updatedParts[index].vc_UnitOfSale = newValue; // Update vc_UnitOfSale with the new value
        setParts(updatedParts); // Update state
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        try {
            debugger;
            const validationErrors = {};

            const partsWithStock = parts.filter(part => part.PK_Stock_ID > 0);
            const partsWithoutDepot = partsWithStock.filter(part =>
                !selectedDepot[part.PK_SalesOrderItem_ID] || !selectedDepot[part.PK_SalesOrderItem_ID].PK_StockLocation_ID
            );
            if (partsWithoutDepot.length > 0) {
                validationErrors.depot = 'Please select a depot for all parts';
            }
            if (Object.keys(validationErrors).length > 0) {
                setErrors(validationErrors);
                return;
            }

            let totalQuantity = 0; // Assume status is 1 by default
            for (const part of parts) {
                const total = parseFloat(part.vc_UnitOfSale) + parseFloat(part.dec_QuantityShipped);


                totalQuantity = totalQuantity + parseFloat(part.vc_UnitOfSale);
            }
            formData.totalQuantity = totalQuantity;
            debugger;
            const formDataWithParts = {
                formData: formData,
                selectedParts: parts.map(part => ({
                    ...part,
                    PK_StockLocation_ID: selectedDepot[part.PK_SalesOrderItem_ID]?.PK_StockLocation_ID || part.FK_Location_ID_Stock || null,
                    DepotQuantity: part.DepotQuantity
                })),
            };
            const postData = await SaleOrderService.AllocateSaleOrder(formDataWithParts);
            if (postData.message === "Data saved successfully") {
                localStorage.setItem('HasRecordUpdated', "1");
                Swal.fire(
                    '',
                    'The Sales order allocated successfully.',
                    'success'
                );
                OnSuccess();
            }


        } catch (error) {
            console.error('Error submitting form:', error);
            setErrors({ submit: 'An error occurred while submitting the form. Please try again.' });
        }
    };
    return (
        <div className={`modal fade ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none' }} tabIndex="-1" aria-labelledby="partModalLabel" aria-hidden={!show}>
            <div className="modal-dialog modal-md">
                <Draggable handle=".modal-content" onStart={handleStart}
                    cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                    <form onSubmit={handleFormSubmit}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="partModalLabel">Select Part</h5>
                                <button type="button" className="btn-close" onClick={onClose} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">

                                <div className="row mb-3" style={{ "marginLeft": "10px", "marginRight": "10px", "marginTop": "10px" }}>
                                    <label htmlFor="bnt_OrderNumber" className="col-sm-2 col-form-label">Sales Order:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="bnt_OrderNumber" value={formData.bnt_OrderNumber} onChange={handleFieldChange} />
                                        {errors.bnt_OrderNumber && <div style={{ color: 'red' }}>{errors.bnt_OrderNumber}</div>}
                                    </div>

                                </div>

                                {/* Table to list parts */}
                                <div className="row mb-3" style={{ "marginLeft": "10px", "marginRight": "10px", "marginTop": "10px" }}>
                                    <table className="table table-striped table-bordered" ref={tableRef} style={{ width: "100%" }}>
                                        <thead>
                                            <tr>
                                                <th className="no-wrap">Product Code</th>
                                                <th className="no-wrap">Description</th>
                                                <th className="no-wrap">Depot</th>
                                                <th className="no-wrap">Allocated</th>
                                                <th className="no-wrap">Required</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {parts.map((part, index) => {
                                                // Ensure vc_UnitOfSale is set to 0 if it's not already set
                                                if (!part.vc_UnitOfSale) {
                                                    part.vc_UnitOfSale = 0;
                                                }
                                                const allocatedQty = part.PK_Stock_ID === 0 ? 0 : part.dec_QtyAllocated;
                                                const requiredQty =
                                                    part.PK_Stock_ID === 0
                                                        ? 0
                                                        : part.vc_UnitOfSale - (parseInt(part.dec_QtyAllocated) + parseInt(part.dec_QuantityShipped || 0));
                                                return (
                                                    <tr key={part.PK_SalesOrderItem_ID}>
                                                        <td className="no-wrap">{truncateText(part.vc_StockCode)}</td>
                                                        <td className="no-wrap">{truncateText(part.vc_Description)}</td>
                                                        <td className="no-wrap">
                                                            {part.PK_Stock_ID > 0 && (
                                                                <div className="depot-selection">
                                                                    <span
                                                                        className="selected-depot"
                                                                        onClick={() => openDepotModal(part.PK_Stock_ID, part.PK_SalesOrderItem_ID)}
                                                                        style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                                                                    >
                                                                        {selectedDepot[part.PK_SalesOrderItem_ID]?.vc_Name // Check if depot has been selected
                                                                            || (part.FK_Location_ID_Stock > 0
                                                                                ? `${part.vc_Name}` // Placeholder until stockLocationList is loaded
                                                                                : 'Select Depot')}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </td>

                                                        <td className="no-wrap">{truncateText(allocatedQty)}</td>



                                                        <td className="no-wrap">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={requiredQty}
                                                                disabled="true"
                                                                onChange={(e) => handlePartChange(index, e.target.value)}  // Allow changes
                                                            />
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                    {errors.depot && <div style={{ color: 'red' }}>{errors.depot}</div>}
                                </div>


                                {/* Modal for selecting depot */}
                                {showDepotModal && (
                                    <div className="modal fade show" style={{ display: 'block' }}>
                                        <div className="modal-dialog">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title">Select Depot</h5>
                                                    <button type="button" className="btn-close" onClick={() => setShowDepotModal(false)}></button>
                                                </div>
                                                <div className="modal-body">
                                                    <table className="table">
                                                        {stockLocationList.map((depot) => (
                                                            <tr>
                                                                <td
                                                                    key={depot.PK_StockLocation_ID}
                                                                    className="list-group-item"
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => handleDepotSelect(depot)}
                                                                >
                                                                    {depot.vc_Name}
                                                                </td>
                                                                <td>
                                                                    {depot.dec_Quantity}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                )}

                            </div>

                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                    <i className="icofont-save" aria-hidden="true">
                                        Save
                                    </i>
                                </button>
                                <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
                            </div>
                        </div>
                    </form>
                </Draggable>
            </div>
        </div>
    );
}

export default SaleOrderShippedModal;
